import axios from '../erp/configAxiosClean';

export const postToStaffRegistration = async (requestData) => {
  return await axios.post('/staff/create/', requestData);
};
